///<reference path="../typings/index.d.ts" />
import "angular";
import "angular-messages";
import "@iamadamjowett/angular-click-outside";
import "angular-ui-bootstrap";
import "angular-ui-tinymce";
import "angular-sanitize";
import "angular-resizable";
import "angular-google-chart";
import "angular-hotkeys";
import "angular-js-xlsx";
import { AngularModule } from "@fiqas/angular-utils";
import { FqComponents } from "@fiqas/angular-components";

export var FIQAssist = AngularModule.Create('FIQAssist', [
    FqComponents.name,
    'ngSanitize',
    'ngComponentRouter',
    'angular-click-outside',
    'angularResizable',
    'cfp.hotkeys',
    'ngMessages',
    'ui.bootstrap',
    'ui.tinymce',
    'googlechart',
    'angular-js-xlsx'
]);
FIQAssist.run(['$q', '$window', ($q, $window) => {
    $window.Promise = function (executor) {
        return $q(executor);
    };

    $window.Promise.all = $q.all.bind($q);
    $window.Promise.reject = $q.reject.bind($q);
    $window.Promise.resolve = $q.when.bind($q);

    $window.Promise.race = function (promises) {
        var promiseMgr = $q.defer();

        for (var i = 0; i < promises.length; i++) {
            promises[i].then(function (result) {
                if (promiseMgr) {
                    promiseMgr.resolve(result);
                    promiseMgr = null;
                }
            });

            promises[i].catch(function (result) {
                if (promiseMgr) {
                    promiseMgr.reject(result);
                    promiseMgr = null;
                }
            });
        }

        return promiseMgr.promise;
    };
}]);
